import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BenefitsHeroComponent } from '../../components/benefits/benefits-hero/benefits-hero.component';
import { CatalogOffersComponent } from '../../components/benefits/catalog-offers/catalog-offers.component';
import { ExclusiveDiscountsComponent } from "../../components/benefits/exclusive-discounts/exclusive-discounts.component";
import { PermanentDiscountsComponent } from "../../components/benefits/permanent-discounts/permanent-discounts.component";
import { ApplyBannerComponent } from "../../components/common/apply-banner/apply-banner.component";
import { CTABannerComponent } from '../../components/common/cta-banner/cta-banner.component';
import { FloatingButtonsComponent } from '../../components/common/floating-buttons/floating-buttons.component';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-beneficios',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    BenefitsHeroComponent,
    CatalogOffersComponent,
    ExclusiveDiscountsComponent,
    PermanentDiscountsComponent,
    ApplyBannerComponent,
    CTABannerComponent,
    FloatingButtonsComponent
],
  templateUrl: './beneficios.component.html',
  styles: []
})
export class BeneficiosComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('beneficiosPage', { static: false }) beneficiosPage?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // Track page view
    this.analyticsService.trackPageView('Beneficios', '/beneficios');
  }

  ngAfterViewInit() {
    // Registrar la página completa para tracking de analytics
    if (this.beneficiosPage?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.beneficiosPage.nativeElement,
        'Beneficios Page',
        'beneficios-page-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }
}
